import React from 'react';
import { useDispatch } from 'react-redux';
import { Alert, AlertTitle, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { ReactFlowProvider } from 'reactflow';
import 'reactflow/dist/style.css';

import { Icon, useModel, useSettings, Utils } from 'app/main/components';
import WbsGraphViewer from './WbsGraphViewer';

export default function WbsTab({ root, updateRefresh }) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(root.table);

	const { save } = useModel({
		baseModel: {
			[`${settings.modu_short}_uid`]: root.tableId,
			[`${settings.modu_short}_wbs`]: 1,
			[`${settings.modu_short}_wbs_editable`]: 1
		},
		settings,
		isEdit: true
	});

	function createWbs() {
		save({
			onSuccess: () => {
				dispatch(Utils.alertSuccessMsg(t, 'ALERT_UPDATE_SUCCESS'));
				updateRefresh();
			}
		});
	}

	return root.hasWbs ? (
		<ReactFlowProvider>
			<WbsGraphViewer root={root} />
		</ReactFlowProvider>
	) : (
		<Paper className="rounded-8" variant="outlined">
			<Alert
				className="rounded-8"
				severity="info"
				icon={<Icon icon="info-circle" />}
				action={
					<Tooltip title={t('NEW')} arrow>
						<IconButton onClick={createWbs}>
							<Icon icon="plus-circle" />
						</IconButton>
					</Tooltip>
				}
			>
				<AlertTitle>{t('WBS_SECTION_NEW_TITLE')}</AlertTitle>
				<Typography> {t('WBS_SECTION_NEW_SUBHEADER')}</Typography>
			</Alert>
		</Paper>
	);
}
